export enum AktorType {
  PERSON = 'aktortype.person',
  VIRKSOMHET = 'aktortype.virksomhet',
  ANNEN_AKTOR = 'aktortype.annenaktor',
}
